import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum TransporterSearchFields {
	searchByName = 'searchByName',
	searchByDotId = 'searchByDotId',
	searchByEpaId = 'searchByEpaId',
	searchSupplierById = 'searchSupplierById',
	searchSupplierByName = 'searchSupplierByName',
	searchSupplierLocationById = 'searchSupplierLocationById',
	searchSupplierLocationByName = 'searchSupplierLocationByName'
}

export enum TransporterShortSearchFields {
	shortId = 'shortId'
}

export type TransporterSearch = TransporterSearchFields | TransporterShortSearchFields

export enum TransporterFilterFields {
	includeInactiveTransporters = 'includeInactiveTransporters',
	includeInactiveSupplierLocations = 'includeInactiveSupplierLocations',
	includeInactiveSuppliers = 'includeInactiveSuppliers'
}

export declare namespace Transporter {
	interface Supplier extends Entity {
		isActive: boolean
	}

	interface SupplierLocation extends Entity {
		city: string
		stateCode: string
		status: string
		isActive: boolean
	}

	interface Basic extends Entity {
		dotId: string
		epaId: string
		isActive: boolean
		supplier: Supplier
		supplierLocation: SupplierLocation
	}

	interface BasicFormId extends Basic {
		isApproved: boolean
		isTurkish: boolean
	}

	namespace Form {
		interface AddTransporter extends Omit<Basic, 'supplier' | 'supplierLocation' | 'id'> {
			name: string
			isApproved: boolean
			supplierLocation: LabelValue | null
		}

		interface NewTransporter extends Omit<AddTransporter, 'supplierLocation'> {
			supplierLocationId: number
		}
	}
	namespace Search {
		interface Config {
			[TransporterSearchFields.searchByName]: ConfigItem<TransporterSearch>
			[TransporterSearchFields.searchByDotId]: ConfigItem<TransporterSearch>
			[TransporterSearchFields.searchByEpaId]: ConfigItem<TransporterSearch>
			[TransporterSearchFields.searchSupplierById]: ConfigItem<TransporterSearch>
			[TransporterSearchFields.searchSupplierByName]: ConfigItem<TransporterSearch>
			[TransporterSearchFields.searchSupplierLocationById]: ConfigItem<TransporterSearch>
			[TransporterSearchFields.searchSupplierLocationByName]: ConfigItem<TransporterSearch>
			[TransporterShortSearchFields.shortId]: ConfigItem<TransporterSearch>
		}

		interface Result {
			[TransporterSearchFields.searchByName]: string[]
			[TransporterSearchFields.searchByDotId]: string[]
			[TransporterSearchFields.searchByEpaId]: string[]
			[TransporterSearchFields.searchSupplierById]: string[]
			[TransporterSearchFields.searchSupplierByName]: string[]
			[TransporterSearchFields.searchSupplierLocationById]: string[]
			[TransporterSearchFields.searchSupplierLocationByName]: string[]
		}
	}
	namespace Filter {
		interface Config {
			[TransporterFilterFields.includeInactiveTransporters]: ConfigFilterItem<string, boolean>
			[TransporterFilterFields.includeInactiveSuppliers]: ConfigFilterItem<string, boolean>
			[TransporterFilterFields.includeInactiveSupplierLocations]: ConfigFilterItem<
				string,
				boolean
			>
		}
	}
}
